import { Select as AntdSelect } from '@firesoon/antd';
import React, { FC } from 'react';
import VirtualSelect from './components/VirtualSelect';
import { Provider } from './context';
import './index.less';
import { CustomSelectProps, SelectDecorator } from './interface';

const { Option } = AntdSelect;

const Index: FC<CustomSelectProps> = ({
  data = [],
  name = 'name',
  code = 'code',
  initials = 'initials',
  showSearch = true,
  hasAll = true,
  allCode = 'all',
  allLabel = '全部',
  allInitials = '',
  hideLabel = false,
  wrapClassName = '',
  virtual = false,
  label = '',
  logRender = 'select',
  defaultActiveFirstOption = false,
  children,
  ...rest
}) => {
  const { value, mode } = rest;
  const showArrow = !(mode != null && value != null && Array.isArray(value) && value.length);
  const Select = virtual ? VirtualSelect : AntdSelect;

  // const formatMultipleOption = (option) => {
  //   // 需要断言为数组
  //   const list = value as Array<any>;

  //   return <>
  //     <Checkbox checked={list != null && list.includes(option[code])}></Checkbox> {option[name]}
  //   </>;
  // };

  const formatOption = (children) => {
    if (children != null) {
      return children;
    }

    let result: any = [];
    const config = {
      'data-log-value': logRender === 'option' ? label : null,
    };

    if (isSingle && hasAll) {
      result.push(
        <Option key={allCode} value={allCode} title={allLabel} data-word={allInitials} {...config}>
          {allLabel}
        </Option>,
      );
    }
    data.forEach((item, index) => {
      result.push(
        <Option
          key={index}
          title={item[name]}
          value={item[code]}
          data-word={item[initials] || ''}
          disabled={item.disabled}
          {...config}
        >
          {item[name]}
          {/* {isSingle ? item[name] : formatMultipleOption(item)} */}
        </Option>,
      );
    });

    return result;
  };

  const isSingle = mode == null;

  return (
    <Provider value={{ virtual }}>
      <div className={`fs-select-wrap ${wrapClassName}`} data-log-value={logRender === 'select' ? label : null}>
        {!hideLabel && label && (
          <label htmlFor="" className="fs-select-label">
            {label}
          </label>
        )}

        <Select
          placeholder="请选择"
          dropdownClassName="fs-select-dropdown"
          className="fs-select"
          showArrow={showArrow}
          showSearch={showSearch}
          defaultActiveFirstOption={defaultActiveFirstOption}
          filterOption={
            showSearch
              ? (value, opt) => {
                  return (
                    String(opt.props.children)?.toUpperCase().includes(value.toUpperCase()) ||
                    opt.props['data-word']?.toUpperCase().includes(value.toUpperCase())
                  );
                }
              : true
          }
          style={{ minWidth: 120 }}
          {...rest}
        >
          {formatOption(children)}
        </Select>
      </div>
    </Provider>
  );
};

Object.assign(Index, { Option });

export default Index as SelectDecorator;
